import {config} from '../config';

const createLink = (type , data = {}) => {
    data = {
        username : "",
        slug : "",
        profile : {
            gender : 0
        },
        ...data
    };
    switch(type){
        //Profile Users
        case"userProfile":
            return `/${config.genderUrl[data.profile.gender]}/${data.slug}`;
        
        case"userDating":
            return `/${config.genderUrl[data.profile.gender]}/${data.slug}/rencontre`;

        case"userStatusOne":
            return `/${config.genderUrl[data.profile.gender]}/${data.slug}/status/${data.status._id}`;

        case"userNotificationOne":
            return `/${config.genderUrl[data.profile.gender]}/${data.slug}/notification/${data.notification._id}`;
        
        case"userAlbums":
            return `/exhibition-sexe/${data.slug}`;
        
        case"userAlbum":
            return `/exhibition-sexe/${data.slug}/${data.album.slug}_${data.album._id}`;

        case"userMedias":
            return `/exhibition-sexe/${data.slug}/medias`;

        case"userMediasSfw":
            return  `/${config.genderUrl[data.profile.gender]}/${data.slug}/en-avant`;
        
        case"userArticles":
            return data && data.blog && data.blog.title ? `/blog-sexe-amateur/${data.slug}/${data.blog.slug}` : `/blog-sexe-amateur/${data.slug}`;
        
        case"userFriends":
            return `/${config.genderUrl[data.profile.gender]}/${data.slug}/amis`;
        
            // Mon profile
        case"userMe":
            return `/mon-profil`;
        
        case"userMeDating":
            return `/mon-profil/rencontre`;

        case"userMeStatusOne":
            return `/mon-profil/status/${data.status._id}`;

        case"userMeNotificationOne":
            return `/mon-profil/notification/${data.notification._id}`;
        
        case"userMeAlbums":
            return `/mon-profil/albums`;
        
        case"userMeAlbum":
            return `/mon-profil/albums/${data.album.slug}_${data.album._id}`;
        
        case"userMeArticles":
            return `/mon-profil/articles`;

        case"userMeMediasSfw":
            return `/mon-profil/en-avant`;
        
        case"userMeFriends":
            return `/mon-profil/amis`;

            //PROFILE ME SETTINGS
        case"userMeSettings":
            return `/mon-profil/parametres/`;
        
        case"userMeSettingsOptionsNotifications":
            return `/mon-profil/parametres/options-notifications`;

        case"userMeSettingsDating":
            return `/mon-profil/parametres/rencontre`;

        case"userMeSettingsProfile":
            return `/mon-profil/parametres/profil`;

        case"userMeSettingsFriendsAndRequest":
            return `/mon-profil/parametres/amis-et-demandes`;

        case"userMeSettingsEmailAndPassword":
            return `/mon-profil/parametres/email-mdp`;

        case"userMeSettingsSignature":
            return `/mon-profil/parametres/signature`;

        case"userMeSettingsBlocage":
            return `/mon-profil/parametres/blocage`;

        case"userMeSettingsAbonnement":
            return `/mon-profil/parametres/abonnement`;

        // Page Photos
        case"photos":
            return `/photos-sexe`;
        
        // Page Videos
        case"videos":
            return `/videos-sexe`;
        
        // Page MediaViewer
        case"mediaviewerPhoto":
            return `/xxx-photos/${data.media.slug}_${data.media._id}`;
        
        case"mediaviewerVideo":
            return `/xxx-videos/${data.media.slug}_${data.media._id}`;
        
        // Actualité
        case"actuality":
            return `/fil-actualite`;
        
        // Moderation Commentaire
        case"commentsModeration":
            return `/moderation-commentaire`;

        case"commentsModerationArticles":
            return `/moderation-commentaire/articles`;

        case"commentsModerationStories":
            return `/moderation-commentaire/histoires`;

        case"commentsModerationStatus":
            return `/moderation-commentaire/status`;
        
        // Forum
        case"forum":
            return `/forum-sex`;
        case"forumLastTopics":
            return `/forum-sex/derniers-messages`;
        
        case"forumCategory":
            return data.categoryParent && data.categoryParent.slug ? `/forum-sex/${data.categoryParent.slug}/${data.category.slug}` : `/forum-sex/${data.category.slug}`;
    
        case"forumTopic":
            let topicUrl =  data.categoryParent && data.categoryParent.slug ? `/forum-sex/${data.categoryParent.slug}/${data.category.slug}/topic/${data.topic.slug}_${data.topic._id}` : `/forum-sex/${data.category.slug}/topic/${data.topic.slug}_${data.topic._id}`;
            topicUrl = data.topic.page >1 ? `${topicUrl}/${data.topic.page}` : topicUrl;
            return data.topic.ancre ? `${topicUrl}/${data.topic.ancre}` : topicUrl;
    
        // Articles
        case"articles":
            return `/blog-sexe-amateur`;
        
        case"article":
            return `/blog-sexe-amateur/${data.slug}/${data.article.slug}_${data.article._id}`;
        
        // Stories
        case"stories":
            return `/histoires-de-sexe`;

        case"storiesRules":
            return `/histoires-de-sexe/regles`;
        
        // case"story":
        //     return `/histoires-de-sexe/${data.story.slug}_${data.story._id}`;
        
        default : return "";
        // Dating
        case"dating":
            return `/rencontre`;

        case"trustSecurity":
            return `/confiance-et-securite`;

        case"parentalControl":
            return `/controle-parental`;

        case"signup":
            return `/inscription`;

        case"signin":
            return `/connexion`;

        case"firstConnexion" :
            return `/first-connexion`;
        ;

        case"chatWebcam":
            return `/chat-webcams`;

        case"messenger":
            return `/messenger`;
        case"messengerRoom":
            return `/messenger/${data.roomId}`;
        case"messengerCreate":
            return `/messenger/new`;
        case"forgotPassword":
            return `/forgot-password`;

        case"contact":
            return `/contact`;
        case"webcams":
            return `/webcams`;
        case"history":
            return `/historique`;

        case"charter":
            return `/charte`;
    
        case"cgus":
            return `/cgus`;
    
        /*case"deleteAccount":
            return `/suppression-de-compte`;*/
    
        case"privacyPolicy":
            return `/privacypolicy`;
    
        case"recherche":
            return `/recherche`;

        case"pcModerator" :
            return `/pc-moderateur`

        case"deleteAccount" :
            return `/supprimer-mon-compte`;

        case"facette":
            return data.slug ? `/f/${data.slug}` : `/f/`;

        case"comparatorDating":
            return "/comparateur/rencontres";

        case"tagModerationQualifications":
            return "/tag-moderations/qualifications";
        case"tagModerationVerifications":
            return "/tag-moderations/verifications";
        case"tagModerationTreatmentVideo":
            return "/tag-moderations/traitements-video";

        case"tagModerationMediasSfw":
            return "/tag-moderations/medias-sfw";

        case"tagPhoto":
            return data.slug ? `/photo-sexe/${data.tag.slug}/${data.slug}${data.showAll === "all" ? "/all" : ""}` : `/photo-sexe/${data.tag.slug}`;
        case"tagVideo":
            return data.slug ? `/video-sexe/${data.tag.slug}/${data.slug}${data.showAll === "all" ? "/all" : ""}` : `/video-sexe/${data.tag.slug}`;
        case"tagStory":
            return data.slug ? `/histoire-de-sexe/${data.tag.slug}/${data.slug}${data.showAll === "all" ? "/all" : ""}` : `/histoire-de-sexe/${data.tag.slug}`;
        case"tagArticle":
            return data.slug ? `/article-sexe/${data.tag.slug}/${data.slug}${data.showAll === "all" ? "/all" : ""}` : `/article-sexe/${data.tag.slug}`;
    }
};

// createLink("charter");
export default createLink;
